import { Injectable } from '@angular/core';
import { OrderStateCode } from 'src/app/core/constants/order-constants';
import { 
    InsightPassengerAddressModel, 
    InsightPassengerCommunicationOtherModel, 
    InsightPassengerCommunicationPhoneModel, 
    InsightPassengerModel, 
    InsightPassengerNameModel, 
    InvoiceIndividualDetailModel,
} from 'src/app/core/models/individual-model';
import { OrderAddress, OrderDataModel } from 'src/app/core/models/order-model/order-json';

@Injectable()
export class InvoiceIndividualDetailMapperService {
    
    public InsightPassengerDetailToInvoiceIndividual(insight: InsightPassengerModel, individualAddressId: string): InvoiceIndividualDetailModel {
        let primaryName = this.getPrimaryName(insight.insightPassengerNames);
        let primaryPhone = this.getPrimaryPhone(insight.insightPassengerCommunicationPhones);
        let primaryCommunication = this.getPrimaryCommunicationOther(insight.insightPassengerCommunicationOthers);

        let individual: InvoiceIndividualDetailModel = {
            individualId: insight.individualId,
            firstName: primaryName.firstName,
            lastName: primaryName.lastName,
            titleCode: primaryName.individualTitleCode,
            languageCode: primaryName.languageCode,
            phoneTypeCode: primaryPhone?.communicationPhoneTypeCode,
            phonePrefix: primaryPhone?.communicationPhonePrefix,
            phoneNumber: primaryPhone?.phoneNumber,
            mailAddress: primaryCommunication?.mailAddress,
            InvoiceAddress: this.getInvoiceAddress(insight?.insightPassengerAddresses, individualAddressId)
        }
        return individual;
    }

    private getPrimaryName(names: InsightPassengerNameModel[]): InsightPassengerNameModel {
        return names.find(name => name.primaryFlag === true);
    }

    private getPrimaryPhone(phones: InsightPassengerCommunicationPhoneModel[]): InsightPassengerCommunicationPhoneModel {
        return phones.find(phone => phone.primaryFlag === true) ?? phones?.[0];
    }

    private getPrimaryCommunicationOther(communications: InsightPassengerCommunicationOtherModel[]): InsightPassengerCommunicationOtherModel {
        return communications.find(communication => communication.primaryFlag === true) ?? communications?.[0];
    }

    private getInvoiceAddress(addresses: InsightPassengerAddressModel[], addressId: string): InsightPassengerAddressModel {
        return addresses.find(address => address.addressId === addressId);
    }

    public orderPartnerContactToInvoiceIndividual(contact: OrderDataModel, orders: OrderDataModel[]): InvoiceIndividualDetailModel {
        if (contact) {
            let orderPartnerContact = contact.orderPartner[0];
            let contactEmail = orders?.find(x => x.orderState?.code == OrderStateCode.CommunicationOther && x.parentOrderId == contact.orderId)?.orderCommunicationOther?.[0];
            let contactPhone = orders?.find(x => x.orderState?.code == OrderStateCode.CommunicationPhone && x.parentOrderId == contact.orderId)?.orderCommunicationPhone?.[0];
            let contactAddress = orders?.find(x => x.orderState?.code == OrderStateCode.Address && x.parentOrderId == contact.orderId)?.orderAddress?.[0];
            let individual: InvoiceIndividualDetailModel = {
                individualId: orderPartnerContact.individualId,
                firstName: orderPartnerContact.orderPartnerName?.firstName,
                lastName: orderPartnerContact.orderPartnerName?.lastName,
                titleCode: orderPartnerContact.orderPartnerName?.individualTitle?.code,
                languageCode: orderPartnerContact.orderPartnerName?.language?.code,
                phoneTypeCode: contactPhone?.communicationPhoneType?.code,
                phonePrefix: contactPhone?.country?.phonePrefix,
                phoneNumber: contactPhone?.phoneNumber,
                mailAddress: contactEmail.mailAddress,
                InvoiceAddress: this.orderAddressToInvoiceAdderssModel(contactAddress)
            }
            return individual;
        }
    }

    private orderAddressToInvoiceAdderssModel(orderAddress: OrderAddress): InsightPassengerAddressModel {
        return {
            addressId: orderAddress?.addressId,
            individualId: orderAddress?.individualId,
            useAddressId: null,
            countryCode: orderAddress?.country?.code,
            addressLine1: orderAddress?.addressLine1,
            addressLine2: orderAddress?.addressLine2,
            postalCode: orderAddress?.postalCode,
            state: orderAddress?.state,
            province: orderAddress?.province,
            city: orderAddress?.city,
            primaryFlag: orderAddress?.primaryFlag,
            locationId: orderAddress?.location?.id,
            addressTypeCode: orderAddress?.addressType?.code,
            addressTypeName: orderAddress?.addressType?.name,
            countryName: orderAddress?.country?.name,
            locationName: orderAddress?.location?.name,
            organisationId: null,
        } as InsightPassengerAddressModel
    }
}
